import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE, COLOR_PURPLE_HOVER } from 'styles/variables/colors';
import { FONT_FAMILY } from 'styles/variables/typography';

export const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    color: COLOR_PURPLE_HOVER,
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 'inherit',
    fontFamily: FONT_FAMILY,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  sectionSubtitle: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    textAlign: 'center',
    color: COLOR_GRAY_70,
    marginBottom: theme.spacing(2.5),
  },
  cardCustomClassName: {
    padding: theme.spacing(3),
  },
  featuresList: {
    marginTop: theme.spacing(4),

    '& h3': {
      fontFamily: FONT_FAMILY,
      fontSize: 18,
      fontWeight: 700,
      textAlign: 'center',
      color: COLOR_PURPLE,
      margin: theme.spacing(0, 2, 0, 2),
    },

    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: theme.spacing(2, 0, 0, 0),
    },

    '& li': {
      display: 'flex',
      alignItems: 'top',
      gap: theme.spacing(1),
      fontFamily: FONT_FAMILY,
    },

    '& li + li': {
      marginTop: theme.spacing(1.5),
    },
  },
  cutThroughLine: {
    backgroundColor: COLOR_PURPLE,
    height: 1,
    minWidth: 100,
    flexGrow: 1,
    flexBasis: 0,
  },
  openFeaturesButton: {
    marginTop: theme.spacing(2),
    color: COLOR_PURPLE,
    fontSize: 14,
    border: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    background: 'transparent',

    '&:hover': {
      color: COLOR_PURPLE_HOVER,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  moreOptionsCardContent: {
    '& h2': {
      fontWeight: 700,
      fontSize: 18,
      color: COLOR_PURPLE,
      marginBottom: theme.spacing(1),
    },

    '& p': {
      fontSize: 14,
      color: COLOR_GRAY_70,
      textWrap: 'pretty',
      marginBottom: theme.spacing(2.5),
    },

    '& h3': {
      fontSize: 32,
      fontWeight: 800,
      color: COLOR_PURPLE,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
  },
}));
